import { render, staticRenderFns } from "./changeVersionDialog.vue?vue&type=template&id=ca4328be&scoped=true"
import script from "./changeVersionDialog.vue?vue&type=script&lang=js"
export * from "./changeVersionDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca4328be",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ca4328be')) {
      api.createRecord('ca4328be', component.options)
    } else {
      api.reload('ca4328be', component.options)
    }
    module.hot.accept("./changeVersionDialog.vue?vue&type=template&id=ca4328be&scoped=true", function () {
      api.rerender('ca4328be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/product/product-details/firmware/changeVersionDialog.vue"
export default component.exports